import {isEqual} from '@shared/helpers/lang'
import {pick} from '@shared/helpers/object'

import {SubscriptionRootState as SubscriptionState} from '../interfaces'

export const getRestoreState = ({
    appState,
    storedState,
}: {
    appState: SubscriptionState
    storedState: SubscriptionState
}) => {
    const compareState = (paths: string[]) => {
        const diff = pick(paths)
        return !isEqual(diff(appState), diff(storedState))
    }

    const isDeliveryDifferent = compareState([
        'deliveryInfo.memo',
        'deliveryInfo.selected',
        'deliveryInfo.virtualPhoneNumber',
    ])

    /** 복원으로 선택된 주소가 변경되었을 경우에만 배송비 재조회 진행하기 위해 별도로 구성 */
    const isDeliveryAddressDifferent = compareState(['deliveryInfo.selected'])

    const isOrderSheetCouponDifferent = compareState(['orderSheetCoupon.useAllCoupon'])

    const shouldRestore = isDeliveryDifferent || isOrderSheetCouponDifferent

    return {shouldRestore, isDeliveryAddressDifferent}
}
